document.addEventListener('DOMContentLoaded', function() {

   // 期限切れのカート商品をチェックして削除する関数
    async function checkExpiredCartItems() {
      try {
        // ローカルストレージからデータを取得
        const savedData = localStorage.getItem('verifiedProductData');
        if (!savedData) return;
        
        const data = JSON.parse(savedData);
        const currentTime = Date.now();
        
        // 24時間経過したかチェック
        if (currentTime > data.expiryTime) {
          // console.log('検証データが期限切れになりました。カートから商品を削除します...');
          
          // カートの内容を取得
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();
          
          // 該当商品がカートにあるかチェック
          const itemToRemove = cart.items.find(item => 
            item.variant_id === data.variantId && 
            item.properties && 
            item.properties['ユーザーID'] === data.userId && 
            item.properties['シリアルナンバー'] === data.serialCode
          );
          
          if (itemToRemove) {
            // 該当商品をカートから削除
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: itemToRemove.key,
                quantity: 0
              })
            });
            
            // console.log('期限切れの商品をカートから削除しました');
          }
          
          // ローカルストレージからデータを削除
          localStorage.removeItem('verifiedProductData');
        } else {
          // まだ期限内の場合、残り時間をログ表示
          const remainingTimeHours = Math.round((data.expiryTime - currentTime) / (60 * 60 * 1000));
          // console.log(`検証データの有効期限まであと約${remainingTimeHours}時間です`);
        }
      } catch (error) {
        console.error('カートの期限切れチェック中にエラーが発生しました:', error);
      }
    }
      // 期限切れのカート商品をチェックして削除
    checkExpiredCartItems();
    // 定期的にカートをチェックする（オプション：5分ごとなど）
    setInterval(checkExpiredCartItems,5000);



});
